module.exports = __webpack_public_path__ + "img/8_of_Hearts.svg.edace5ea.png";